<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">

      <z-page :title="title">
  <div class="space-y-6">
    
    <w-card class="program-card">
        <h3 class="card-title">Maklumat Program Khas</h3>
        <table class="data-table">
          <tbody>
            <tr>
                <td class="label-col">Nama Program</td>
                <td class="separator-col">:</td>
                <td>{{ form.nama_program }}</td>
            </tr>
            <tr>
                <td class="label-col">Tujuan Program</td>
                <td class="separator-col">:</td>
                <td>{{ form.tujuan_program == 2 ? 'Pemeriksaan Dayabiak BSE' : '' }}</td>
            </tr>
            <tr>
                <td class="label-col">Tarikh Program</td>
                <td class="separator-col">:</td>
                <td>
                    Dari {{ $zutil.dateformat(form.tarikh_program_dari) }}
                    <br>
                    Sehingga {{ $zutil.dateformat(form.tarikh_program_hingga) }}
                </td>
            </tr>
            <tr>
                <td class="label-col">Waktu Program</td>
                <td class="separator-col">:</td>
                <td>{{ form.waktu_program }}</td>
            </tr>
            <!-- <tr>
                <td class="label-col">ID | Nama Premis</td>
                <td class="separator-col">:</td>
                <td>{{ form.premis }} | {{ form.nama_premis }}</td>
            </tr> -->
            <tr>
                <td class="label-col">Nama Premis</td>
                <td class="separator-col">:</td>
                <td>{{ form.nama_premis }}</td>
            </tr>
            <tr>
                <td class="label-col">Lokasi</td>
                <td class="separator-col">:</td>
                <td>{{ form.lokasi }}</td>
            </tr>
             <tr>
                <td class="label-col">Nama Pegawai Perekod</td>
                <td class="separator-col">:</td>
                <td>{{ form.nama_user }}</td>
            </tr>
            <tr>
                <td class="label-col pegawai-label">Nama Pegawai Terlibat</td>
                <td class="separator-col pegawai-label">:</td>
                <td>
                    <ul class="pegawai-list">
                        <li v-for="(pegawai, idx) in form.pegawai" :key="idx" class="pegawai-item">
                            {{ pegawai.nama_pegawai }}
                        </li>
                    </ul>
                </td>
            </tr>
            </tbody>
        </table>
    </w-card>

       <w-card class="program-card">
        <w-form ref="zform" v-model="valid" v-model:errors-count="errorsCount" @submit.prevent="validateForm" @success="success">
        <h3 class="card-title result-title">Hasil Selepas Program Khas</h3>
        <table class="data-table input-table">
          <tbody>
            <tr>
                <td class="label-col">Jumlah Ternakan Diperiksa</td>
                <td class="separator-col">:</td>
                <td class="input-cell">
                  <template v-if="$zutil.anyRole(['4']) && $page.props.auth.user.id == form.user_id">
                    <w-input
                        class="input-no-label"
                        outline
                        type="number"
                        v-model="form.jumlah_periksa"
                        @input="kiraTidakBunting"
                    />
                  </template>
                  <template v-else>
                    {{ form.jumlah_periksa }}
                  </template>
                </td>
            </tr>
            <tr>
                <td class="label-col">Jumlah Ternakan Lulus</td>
                <td class="separator-col">:</td>
                <td class="input-cell">
                   <template v-if="$zutil.anyRole(['4']) && $page.props.auth.user.id == form.user_id">
                    <w-input
                        class="input-no-label success-input"
                        outline
                        type="number"
                        v-model="form.jumlah_lulus"
                        @input="kiraTidakBunting"
                    />
                  </template>
                    <template v-else>
                    {{ form.jumlah_lulus }}
                  </template>
                </td>
            </tr>
            <tr>
                <td class="label-col">Jumlah Ternakan Gagal</td>
                <td class="separator-col">:</td>
                <td class="input-cell">
                  <template v-if="$zutil.anyRole(['4']) && $page.props.auth.user.id == form.user_id">
                    <w-input
                        class="input-no-label danger-input"
                        outline
                        type="number"
                        v-model="form.jumlah_gagal"
                        disabled
                    />
                  </template>
                 <template v-else>
                    {{ form.jumlah_gagal }}
                  </template>

                </td>
            </tr>
            <tr>
                <td class="label-col">Fail Lampiran</td>
                <td class="separator-col">:</td>
                <td>
                
                <template v-if="$zutil.anyRole(['4']) && $page.props.auth.user.id == form.user_id">
                  <w-input 
                    class="mt4" 
                    type="file" 
                    :preview="false" 
                    accept="application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    v-model="files_dokumen"
                  >
                    Muat Naik Fail (PDF / Excel)
                  </w-input>

                  <template v-for="(dt, ind) in form.lampiran" :key="dt.id">
                    <div class="fw-normal my1 fs-1 flex items-center gap-2">  
                      <a 
                        :href="dt.file_url" 
                        target="_blank" 
                        class="text-blue-600 underline"
                      >
                        {{ dt.name }}
                      </a>
                      <w-button 
                        bg-color="error-dark1" 
                        size="sm"
                        @click="deletelAttahecment(dt.id)"
                      >
                        <w-icon xs>fal fa-trash</w-icon>
                      </w-button>
                    </div>
                  </template>
                </template>

                
                <template v-else>
                  <template v-for="(dt, ind) in form.lampiran" :key="dt.id">
                    <div class="fw-normal my1 fs-1">  
                      <a 
                        :href="dt.file_url" 
                        target="_blank" 
                        class="text-blue-600 underline"
                      >
                        {{ dt.name }}
                      </a>
                    </div>
                  </template>
                </template>

                <!-- Jika tidak ada file -->
                <span 
                  v-if="!form.lampiran || form.lampiran.length === 0" 
                  class="text-gray-500"
                >
                  Tiada fail
                </span>
              </td>
              </tr>
              </tbody>
        </table>
      </w-form>
    </w-card>

    <div class="mt4 text-right">
      <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>
      &nbsp;
      <template v-if="$zutil.anyRole(['4']) && $page.props.auth.user.id == form.user_id">
      <w-button class="my1" :loading="form.submitted && !form.sent" @click="send(3); onSuccess()">
        <w-icon dark tile class="mr2">fal fa-save</w-icon> SIMPAN
      </w-button>
    </template>
    </div>
  </div>
</z-page>

  </zen-one>
  
</template>



<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'

export default {
  extends: ZResource,
  components: {
    VueperSlides, VueperSlide
  },
  props: {
    id: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'program.program_bse',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        // { label: 'Permohonan Perkhidmatan', route: '/art' },
        { label: 'Program Khas Dayabiak BSE', route: '/program/anak' },
        { label: 'Papar', route: '/program/anak/'+this.id },
      ],
      title : 'Permohonan Pembiakan Perkhidmatan',
      form : {
        id : this.id,
        premis_id : '',
        tarikh_lahir : '',
        lkp_kaedah_kelahiran_id : '',
        lkp_gred_id : '',
        premis_id: null,
        tujuan_program_id: null,
        tarikh_program_dari: null,
        tarikh_program_hingga: null,
        waktu_program: null,
        nama_program: "",
        jumlah_periksa: 0,
        jumlah_lulus: 0,
        jumlah_gagal: 0,
        
      },
      
      attahecment : [],
      files_dokumen:[],
      slides : []
      
      
    }
  },
  methods: {
   
     getData(){
      if(this.form.id > 0){
        this.$zcomm.get(this.api_service + 'art/show-program/'+this.form.id, {}).then(res => {
          this.form = res
          
          this.getAttahecment()
        })
      }
    },
    
    
    getAttahecment()
    {
      this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : this.form.id, model : '\\App\\Model\\ArtButiran'}).then(res => {
        this.attahecment = res
        this.slides = [];
       for (var b in this.attahecment) {
          this.slides.push({title: this.attahecment[b].information, image: this.attahecment[b].url})
       }
      })
    },

    tutup(){
      // if(this.form.lkp_art_id==1){
      //  this.$inertia.visit(this.$route('art.semakan.ai', this.form.art_id)+'?t=2');
      // }else if(this.form.lkp_art_id==2){
      //  this.$inertia.visit(this.$route('art.semakan.pd', this.form.art_id)+'?t=2');
      // }else if(this.form.lkp_art_id==3){
      //  this.$inertia.visit(this.$route('art.semakan.et', this.form.art_id)+'?t=2');
      // }else if(this.form.lkp_art_id==4){
      //  this.$inertia.visit(this.$route('art.semakan.sinkronisasi', this.form.art_id)+'?t=2');
      // }
      this.$inertia.visit(window.route('program.program_bse.index'));
       // this.$inertia.visit(this.$route('art.permohonan.show', this.form.art_id)+'?t=2');
    },

    kiraTidakBunting() {
    const periksa = Number(this.form.jumlah_periksa) || 0;
    const lulus = Number(this.form.jumlah_lulus) || 0;
    this.form.jumlah_gagal = Math.max(periksa - lulus, 0);
  },

    send(hantar){
      this.form.hantar = hantar
    },

    onSuccess() {
      if (this.form.hantar == 1) {
        // === KONFIRMASI UNTUK HANTAR ===
        this.$swal({
          title: 'Anda Pasti?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        }).then((result) => {
          if (result.value) {
            if (this.form.id > 0) {
              this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
                .then(res => {
                  if (typeof this.onAfterEdit === "function") this.onAfterEdit()
                  if (this.files_dokumen.length > 0) this.uploadPDFDokumen(res.id)

                  this.$inertia.visit(this.$route('program.program_bse.index'))
                })
            }
          }
        })
      } else {
        // === SIMPAN (UPDATE SAJA) ===
        if (this.form.id > 0) {
          this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
            .then(res => {
              if (typeof this.onAfterEdit === "function") this.onAfterEdit()
              if (this.files_dokumen.length > 0) this.uploadPDFDokumen(res.id)

              this.$zutil.notify("Berjaya disimpan", true)
              this.$inertia.visit(this.$route('program.program_bse.index'))
            })
        } else {
          // kalau ID kosong, jangan bikin baru
          this.$zutil.notify("Data belum ada untuk diupdate!", false)
        }
      }
    },
    

    uploadImg(item) 
    {  
       let formData = new FormData();
       for (var b in this.files) 
       {
           formData.append("files["+b+"]", this.files[b].file);
       }
       formData.append("model",item);
       formData.append("model_id", this.form.id);
       this.$zcomm.post('attahecment.upload', formData)
           .then((res) => {
               this.getAttahecment();
           })
           .catch((err) => {})
           .finally(() => {});
   },

   uploadPDFDokumen(item) 
    {  
       let formData = new FormData();
       for (var b in this.files_dokumen) 
       {
           formData.append("files["+b+"]", this.files_dokumen[b].file);
       }
       formData.append("model",'\\App\\Model\\ProgramDokumen');
       formData.append("model_id", item);
       this.$zcomm.post('attahecment.upload_replace', formData)
           .then((res) => {
               this.getAttahecmentDokumen();
               this.loadData();
           })
           .catch((err) => {})
           .finally(() => {});
   },

   getAttahecmentDokumen(item)
    {
      this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : item, model : '\\App\\Model\\ProgramDokumen'}).then(res => {
         this.attahecment = res
      })
    },
   
   deletelAttahecment(id) {
      this.$swal({
        title: 'Anda Pasti?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak'
      }).then((result) => {
        if (result.value) {
          this.$zcomm.delete(this.resourceurl + '.destroy_program', id)
            .then(res => {
              this.form.lampiran = this.form.lampiran.filter(item => item.id !== id)
              this.$zutil.notify("Lampiran berhasil dihapus", true)
            })
        }
      })
    },
  },

  watch: {

  },
  mounted() {
    this.getData()
    if(this.id > 0)
    {
      this.title = ' Senarai Program Khas Pemeriksaan Dayabiak BSE'
    }
    else
    {
      this.title = ' Senarai Program Khas Pemeriksaan Dayabiak BSE'
    }
    
  }
    
}
</script>
<style type="text/css">

.program-card {
    padding: 24px; 
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1); 
    border-radius: 8px; 
    background-color: #ffffff; 
    border: 1px solid #e5e7eb; 
}


.card-title {
    font-size: 1.125rem; 
    font-weight: 700; 
    margin-bottom: 16px; 
    color: #312e81; 
    padding-bottom: 8px;
    border-bottom: 2px solid #e0e7ff; 
}


.data-table {
    width: 100%; 
    border-collapse: separate; 
    border-spacing: 0 8px; 
}


.label-col {
    width: 30%; 
    font-weight: 600; 
    color: #4b5563; 
    padding-right: 10px; 
    min-width: 150px; 
}


.separator-col {
    width: 5%; 
    text-align: center;
}


.data-table td {
    padding-top: 4px;
    padding-bottom: 4px;
}


.pegawai-label {
    vertical-align: top; 
}


.pegawai-list {
    list-style-type: decimal; 
    padding-left: 20px; 
    margin-top: 0;
    margin-bottom: 0;
    line-height: 1.5; 
}


.pegawai-list .pegawai-item {
    margin-bottom: 4px; 
    color: #1f2937; 
}


.data-table tr:nth-child(5) td:last-child {
    
    font-weight: 500;
    color: #1f2937; 
}


.result-data {
    font-weight: 700; 
    font-size: 1.125rem; 
    color: #1f2937;
}



.file-link {
    color: #2563eb; 
    text-decoration: underline;
    font-weight: 500;
}


.mt-6 {
    margin-top: 1.5rem; 
}

.input-table .input-cell {
    
    padding-top: 4px;
    padding-bottom: 4px;
}


.input-no-label {
   
    margin: 0 !important;
    
    
    max-width: 200px; 
}


.input-no-label >>> .w-input__field {
    
    height: 32px;
    padding: 4px 8px;
    font-size: 1rem;
    font-weight: 600; 
}


</style>

